export enum ParticipantValidationStages {
  validatingToken = 0,
  tokenValidated = 10,
  settingPassword = 20,
  authenticating = 25,
  tokenError = 30
}
